/* eslint-disable no-empty */
import React from 'react';

interface ITopicContainerProps {
  className?: string;
}

const TopicContainer: React.FunctionComponent<ITopicContainerProps> = (
  props
) => {
  return (
    <div className={`course-body-content ${props.className || ''}`}>
      {props.children}
    </div>
  );
};

export default TopicContainer;
